import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem poem-dialog">

      <p class="poem-block mb-3">
        Halo, ĉu klubo «Verda Harmonio»? <br/>
        Forestis mi dum longa jar’. <br/>
        Dum tiu temp’ okazis kio? <br/>
        Rakontu do, ho amikar’!
      </p>

      <p class="poem-block mb-3">
        Bonordas ĉio, kara klubanino, <br/>
        Nenia mav’ minacas nin. <br/>
        Dorlotas nin videble la destino <br/>
        Kaj ni prosperas sen la fin’. <br/>
        Nun malgravaĵo, bagatelo : <br/>
        Perdiĝis nia verda stelo, <br/>
        Sed en alio, kara klubanino, <br/>
        Bonordas ni, bonordas ni!
      </p>


      <p class="poem-block mb-3">
        O-la-la-la, malbona okazaĵo, <br/>
        Perdiĝis nia verda stel’. <br/>
        Rakontu vi, amiko saĝa, <br/>
        Pri tiu aĉa, aĉa ŝtel’!
      </p>

      <p class="poem-block mb-3">
        Bonordas ĉio, kara klubanino, <br/>
        Ne maltrankvilu vin en van’, <br/>
        Por ni ridetas ĉiam la destino, <br/>
        Maltrafis unu nur kluban’. <br/>
        Li perdis stelon kun la mono <br/>
        Al li donita por abono, <br/>
        Sed en alio, kara klubanino, <br/>
        Bonordas ni, bonordas ni!
      </p>


      <p class="poem-block mb-3">
        O-la-la-la, domaĝas mi terure, <br/>
        Perdita mono de la klub’. <br/>
        Ĉu malaperis ĝi senspure, <br/>
        Rakontu tuj al mi sen dub’!
      </p>

      <p class="poem-block mb-3">
        Bonordas ĉio, kara klubanino, <br/>
        La ĝojo ŝprucas el la kor’, <br/>
        Sed nia sort’, verŝajne pro obstino, <br/>
        Surprizis nin en gaja hor’: <br/>
        Neniun mono interesis, <br/>
        Ĉar nia klub’ funkcii ĉesis, <br/>
        Sed en alio, kara klubanino, <br/>
        Bonordas ni, bonordas ni!
      </p>


      <p class="poem-block mb-3">
        O-la-la-la, suferas la animo, <br/>
        La sortobato pezas tro. <br/>
        Ĉu estas por la plago limo? <br/>
        Kak eto vsjo proizoŝlo? <br/>
        <span class="italic d-block mt-1">Varianto <br/></span>
        <span class="italic" style="font-size:90%;">
          O-la-la-la, suferas la animo, <br/>
          Tro multe da amara gal’. <br/>
          Ĉu estas por la plago limo? <br/>
          Okazis kio en real’?
        </span>
      </p>

      <p class="poem-block mb-3">
        La prezidanto, kara klubanino, <br/>
        Laboris kun grandega pen’. <br/>
        Sed trafis lin malice la destino <br/>
        Kaj li rezignis de l’ posten’. <br/>
        Kiam forlasis klubon li, <br/>
        Obsedis nin melankoli’, <br/>
        Ne volis ni labori plu, <br/>
        Kaj jen disfalis nia klub’, <br/>
        Forgesis ni pri tiu mon’ <br/>
        Kiun kolektis por abon’. <br/>
        La monon ŝtelis kamarad’ <br/>
        Kiu nun sidas post la krad’, <br/>
        Kaj prenis li kun mona sum’ <br/>
        Ankoraŭ stelon en mallum’, <br/>
        Sed en alio, kara klubanino, <br/>
        Bonordas ni, bonordas ni!
      </p>
    </div>
    `
  )
}
const itemName = {
  esp: 'Prekrasnaja markiza'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;